import { Controller } from '@hotwired/stimulus'

// 費用種別タブ（comparison_graph）と施設種別タブ（category_tabs）で切替ロジックが同一のため集約した基底。
// サブクラスは datasetKey()（切替キーになる dataset のキー名）と、テンプレートの data-action が参照する
// switch*(event) の実装が必須。テンプレートとの一致は js_ruby_sync_spec で固定している。
//
// NOTE: ファイル名を component_controller.js にしないのは以下2点のため。
//       1. このディレクトリ自体が Site::Parts::CostMarket::*::Component のもので、
//          そのコンポーネントのコントローラーに見えてしまう
//       2. app/components 配下を require.context でディレクトリ制約なしに全件登録している
//          entrypoint（admin / new_admin / inquiry_* / search_question_*）に拾われ、
//          Stimulusコントローラーとして誤登録される
//       `static targets` は Stimulus 3 の継承（readInheritableStaticArrayValues）で引き継がれる。
export default class extends Controller {
  static targets = ['tab', 'panel']

  switchTab (event) {
    this.select(this.keyOf(event.currentTarget))
  }

  // 矢印キー・Home / End での移動。移動先をそのまま選択する（自動アクティベーション）
  navigate (event) {
    const tabs = this.tabTargets
    const index = tabs.indexOf(event.currentTarget)
    if (index < 0) return

    const last = tabs.length - 1
    const nextIndex = {
      ArrowRight: index === last ? 0 : index + 1,
      ArrowLeft: index === 0 ? last : index - 1,
      Home: 0,
      End: last,
    }[event.key]
    if (nextIndex === undefined) return

    // 矢印キー・Home / End でのページスクロールを抑止する
    event.preventDefault()
    const nextTab = tabs[nextIndex]
    this.select(this.keyOf(nextTab))
    nextTab.focus()
  }

  select (key) {
    this.tabTargets.forEach((tab) => {
      const selected = this.keyOf(tab) === key
      // 見た目のactive・支援技術への通知（aria-selected）・Tabキーの到達先を必ず同時に更新する
      tab.classList.toggle(`${this.className()}::tab-active`, selected)
      tab.setAttribute('aria-selected', String(selected))
      tab.tabIndex = selected ? 0 : -1
    })

    this.panelTargets.forEach((panel) => {
      panel.hidden = this.keyOf(panel) !== key
    })
  }

  keyOf (element) {
    return element.dataset[this.datasetKey()]
  }

  className () {
    return this.element.dataset.classname
  }
}
